// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes BlogDetailWithFormPage_fadeIn__Jrkhv {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.BlogDetailWithFormPage_blogDetailWrapper__CZ61- {
  min-height: 100vh;
  background: linear-gradient(120deg, #f7fbfd 0%, #e6f3fa 100%);
  padding-bottom: 60px;
  animation: BlogDetailWithFormPage_fadeIn__Jrkhv 0.6s ease-out;
  transform-origin: top center;
}

.BlogDetailWithFormPage_textContainer__bBI2i {
  max-width: 80%;
  margin: 0 auto;
  padding: 48px 16px 0 16px;
}

.BlogDetailWithFormPage_illustration__3QGhR {
  display: block;
  margin: 0 auto 48px auto;
  width: 340px;
  max-width: 100%;
}

.BlogDetailWithFormPage_heading__xoRJe {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 40px;
}

.BlogDetailWithFormPage_subheading__tnDlY {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 32px;
}

.BlogDetailWithFormPage_paragraph__UWj8F {
  color: #222;
  font-size: 19px;
  line-height: 1.8;
  margin-bottom: 40px;
}

.BlogDetailWithFormPage_textSection__Sjet7 {
  color: #222;
  font-size: 19px;
  line-height: 1.8;
  margin-bottom: 56px;
}

.BlogDetailWithFormPage_formWrapper__a2e6X {
  max-width: 50%;
  margin: 0 auto;
  background: #c45bae;
  border-radius: 18px;
  padding: 48px 40px 40px 40px;
  margin-top: 64px;
  box-shadow: 0 4px 32px rgba(196, 91, 174, 0.08);
}

.BlogDetailWithFormPage_formTitle__bSmT7 {
  text-align: center;
  color: #111;
  font-weight: 700;
  font-size: 28px;
  margin-bottom: 36px;
}

.BlogDetailWithFormPage_form__g\\+HT8 {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.BlogDetailWithFormPage_formRow__ziyF1 {
  display: flex;
  gap: 24px;
}

.BlogDetailWithFormPage_formCol__KjBre {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.BlogDetailWithFormPage_label__MO3Hv {
  color: #fff;
  font-weight: 500;
  margin-bottom: 2px;
}

.BlogDetailWithFormPage_input__HOxYY {
  border-radius: 6px;
  border: none;
  padding: 13px 14px;
  font-size: 17px;
  background: #fff;
  color: #222;
}

.BlogDetailWithFormPage_button__DvPVe {
  margin-top: 16px;
  background: #6be0e0;
  color: #222;
  border: none;
  border-radius: 6px;
  padding: 16px 0;
  font-weight: 700;
  font-size: 20px;
  cursor: pointer;
}

@media (max-width: 600px) {
  .BlogDetailWithFormPage_textContainer__bBI2i {
    max-width: 100%;
    padding: 24px 4vw 0 4vw;
  }
  .BlogDetailWithFormPage_illustration__3QGhR {
    margin-top: 24px;
    width: 60vw;
    margin-bottom: 28px;
  }
  .BlogDetailWithFormPage_heading__xoRJe {
    font-size: 22px;
    margin-bottom: 24px;
  }
  .BlogDetailWithFormPage_subheading__tnDlY {
    font-size: 18px;
    margin-bottom: 18px;
  }
  .BlogDetailWithFormPage_paragraph__UWj8F,
  .BlogDetailWithFormPage_textSection__Sjet7 {
    font-size: 15px;
    margin-bottom: 24px;
  }
  .BlogDetailWithFormPage_formWrapper__a2e6X {
    max-width: 98vw;
    padding: 24px 8px 18px 8px;
    margin-top: 32px;
  }
  .BlogDetailWithFormPage_formTitle__bSmT7 {
    font-size: 19px;
    margin-bottom: 18px;
  }
  .BlogDetailWithFormPage_form__g\\+HT8 {
    gap: 14px;
  }
  .BlogDetailWithFormPage_formRow__ziyF1 {
    flex-direction: column;
    gap: 12px;
  }
  .BlogDetailWithFormPage_input__HOxYY {
    font-size: 15px;
    padding: 10px 10px;
  }
  .BlogDetailWithFormPage_button__DvPVe {
    font-size: 16px;
    padding: 12px 0;
    margin-top: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/FormPage/BlogDetailWithFormPage.module.scss"],"names":[],"mappings":"AAAA;EACE;IACE,UAAA;IACA,uCAAA;EACF;EACA;IACE,UAAA;IACA,iCAAA;EACF;AACF;AAEA;EACE,iBAAA;EACA,6DAAA;EACA,oBAAA;EACA,6DAAA;EACA,4BAAA;AAAF;;AAGA;EACE,cAAA;EACA,cAAA;EACA,yBAAA;AAAF;;AAEA;EACE,cAAA;EACA,wBAAA;EACA,YAAA;EACA,eAAA;AACF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAEF;;AAAA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAGF;;AADA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAIF;;AAFA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAKF;;AAHA;EACE,cAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;EACA,+CAAA;AAMF;;AAJA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAOF;;AALA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAQF;;AANA;EACE,aAAA;EACA,SAAA;AASF;;AAPA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAUF;;AARA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AAWF;;AATA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAYF;;AAVA;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAaF;;AAVA;EACE;IACE,eAAA;IACA,uBAAA;EAaF;EAXA;IACE,gBAAA;IACA,WAAA;IAEA,mBAAA;EAYF;EAVA;IACE,eAAA;IACA,mBAAA;EAYF;EAVA;IACE,eAAA;IACA,mBAAA;EAYF;EAVA;;IAEE,eAAA;IACA,mBAAA;EAYF;EAVA;IACE,eAAA;IACA,0BAAA;IACA,gBAAA;EAYF;EAVA;IACE,eAAA;IACA,mBAAA;EAYF;EAVA;IACE,SAAA;EAYF;EAVA;IACE,sBAAA;IACA,SAAA;EAYF;EAVA;IACE,eAAA;IACA,kBAAA;EAYF;EAVA;IACE,eAAA;IACA,eAAA;IACA,gBAAA;EAYF;AACF","sourcesContent":["@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.blogDetailWrapper {\n  min-height: 100vh;\n  background: linear-gradient(120deg, #f7fbfd 0%, #e6f3fa 100%);\n  padding-bottom: 60px;\n  animation: fadeIn 0.6s ease-out;\n  transform-origin: top center;\n}\n\n.textContainer {\n  max-width: 80%;\n  margin: 0 auto;\n  padding: 48px 16px 0 16px;\n}\n.illustration {\n  display: block;\n  margin: 0 auto 48px auto;\n  width: 340px;\n  max-width: 100%;\n}\n.heading {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 40px;\n}\n.subheading {\n  font-size: 26px;\n  font-weight: 700;\n  margin-bottom: 32px;\n}\n.paragraph {\n  color: #222;\n  font-size: 19px;\n  line-height: 1.8;\n  margin-bottom: 40px;\n}\n.textSection {\n  color: #222;\n  font-size: 19px;\n  line-height: 1.8;\n  margin-bottom: 56px;\n}\n.formWrapper {\n  max-width: 50%;\n  margin: 0 auto;\n  background: #c45bae;\n  border-radius: 18px;\n  padding: 48px 40px 40px 40px;\n  margin-top: 64px;\n  box-shadow: 0 4px 32px rgba(196, 91, 174, 0.08);\n}\n.formTitle {\n  text-align: center;\n  color: #111;\n  font-weight: 700;\n  font-size: 28px;\n  margin-bottom: 36px;\n}\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.formRow {\n  display: flex;\n  gap: 24px;\n}\n.formCol {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.label {\n  color: #fff;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n.input {\n  border-radius: 6px;\n  border: none;\n  padding: 13px 14px;\n  font-size: 17px;\n  background: #fff;\n  color: #222;\n}\n.button {\n  margin-top: 16px;\n  background: #6be0e0;\n  color: #222;\n  border: none;\n  border-radius: 6px;\n  padding: 16px 0;\n  font-weight: 700;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n@media (max-width: 600px) {\n  .textContainer {\n    max-width: 100%;\n    padding: 24px 4vw 0 4vw;\n  }\n  .illustration {\n    margin-top: 24px;\n    width: 60vw;\n\n    margin-bottom: 28px;\n  }\n  .heading {\n    font-size: 22px;\n    margin-bottom: 24px;\n  }\n  .subheading {\n    font-size: 18px;\n    margin-bottom: 18px;\n  }\n  .paragraph,\n  .textSection {\n    font-size: 15px;\n    margin-bottom: 24px;\n  }\n  .formWrapper {\n    max-width: 98vw;\n    padding: 24px 8px 18px 8px;\n    margin-top: 32px;\n  }\n  .formTitle {\n    font-size: 19px;\n    margin-bottom: 18px;\n  }\n  .form {\n    gap: 14px;\n  }\n  .formRow {\n    flex-direction: column;\n    gap: 12px;\n  }\n  .input {\n    font-size: 15px;\n    padding: 10px 10px;\n  }\n  .button {\n    font-size: 16px;\n    padding: 12px 0;\n    margin-top: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blogDetailWrapper": `BlogDetailWithFormPage_blogDetailWrapper__CZ61-`,
	"fadeIn": `BlogDetailWithFormPage_fadeIn__Jrkhv`,
	"textContainer": `BlogDetailWithFormPage_textContainer__bBI2i`,
	"illustration": `BlogDetailWithFormPage_illustration__3QGhR`,
	"heading": `BlogDetailWithFormPage_heading__xoRJe`,
	"subheading": `BlogDetailWithFormPage_subheading__tnDlY`,
	"paragraph": `BlogDetailWithFormPage_paragraph__UWj8F`,
	"textSection": `BlogDetailWithFormPage_textSection__Sjet7`,
	"formWrapper": `BlogDetailWithFormPage_formWrapper__a2e6X`,
	"formTitle": `BlogDetailWithFormPage_formTitle__bSmT7`,
	"form": `BlogDetailWithFormPage_form__g+HT8`,
	"formRow": `BlogDetailWithFormPage_formRow__ziyF1`,
	"formCol": `BlogDetailWithFormPage_formCol__KjBre`,
	"label": `BlogDetailWithFormPage_label__MO3Hv`,
	"input": `BlogDetailWithFormPage_input__HOxYY`,
	"button": `BlogDetailWithFormPage_button__DvPVe`
};
export default ___CSS_LOADER_EXPORT___;
